const { gatewayType } = require('./gatewayMapper');
const { transactionStatus } = require('../mappers');

const gatewaysThatCanRefund = [
    gatewayType.acapture,
    gatewayType.aci_auto,
    gatewayType.aci_planet,
    gatewayType.aci_planet_mcp,
    gatewayType.adyen,
    gatewayType.authorize,
    gatewayType.bambora,
    gatewayType.checkout,
    gatewayType.checkout_nas,
    gatewayType.cybersource,
    gatewayType.emerchantpay,
    gatewayType.kushki,
    gatewayType.kushki_ecuador,
    gatewayType.nmi,
    gatewayType.nmi_auto,
    gatewayType.ntt_cybersource,
    gatewayType.openpay,
    gatewayType.payments_os,
    gatewayType.payments_os_asia_pacific,
    gatewayType.payments_os_south_africa,
    gatewayType.payments_os_turkey,
    gatewayType.payments_os_colombia,
    gatewayType.payments_os_russia,
    gatewayType.payments_os_nigeria,
    gatewayType.payments_os_india,
    gatewayType.payments_os_iyzico,
    gatewayType.place_to_pay,
    gatewayType.propay,
    gatewayType.propay_canada,
    gatewayType.powercash,
    gatewayType.reach,
    gatewayType.stripe,
    gatewayType.switch,
    gatewayType.switch_kicc,
    gatewayType.trust_my_travel,
    gatewayType.usaepay,
    gatewayType.zeamster,
    gatewayType.nexio,
    gatewayType.nexio_async,
    gatewayType.nexio_auto
];

const gatewaysThatCanVoid = [
    {
        gatewayType: gatewayType.usaepay,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.nmi,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.acapture,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.aci_auto,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.nmi_auto,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.aci_planet,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.aci_planet_mcp,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.authorize,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.checkout,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.checkout_nas,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.kushki,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.kushki_ecuador,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.zeamster,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.reach,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.openpay,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_asia_pacific,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_turkey,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_south_africa,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_russia,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_nigeria,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.payments_os_iyzico,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.nexio,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.nexio_auto,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.nexio_async,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.stripe,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.cybersource,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.trust_my_travel,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.propay,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.propay_canada,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.powercash,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.emerchantpay,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.bambora,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    },
    {
        gatewayType: gatewayType.adyen,
        validStatuses: [transactionStatus.authOnly]
    },
    {
        gatewayType: gatewayType.switch,
        validStatuses: [transactionStatus.authOnly]
    },
    {
        gatewayType: gatewayType.ntt_cybersource,
        validStatuses: [transactionStatus.authOnly, transactionStatus.authorized]
    }
];

const gatewaysThatCanCapture = [
    gatewayType.usaepay,
    gatewayType.nmi,
    gatewayType.nmi_auto,
    gatewayType.acapture,
    gatewayType.aci_auto,
    gatewayType.aci_planet,
    gatewayType.aci_planet_mcp,
    gatewayType.authorize,
    gatewayType.checkout,
    gatewayType.checkout_nas,
    gatewayType.kushki,
    gatewayType.kushki_ecuador,
    gatewayType.zeamster,
    gatewayType.reach,
    gatewayType.switch,
    gatewayType.openpay,
    gatewayType.payments_os,
    gatewayType.payments_os_asia_pacific,
    gatewayType.payments_os_turkey,
    gatewayType.payments_os_south_africa,
    gatewayType.payments_os_russia,
    gatewayType.payments_os_nigeria,
    gatewayType.payments_os_iyzico,
    gatewayType.nexio,
    gatewayType.nexio_auto,
    gatewayType.nexio_async,
    gatewayType.stripe,
    gatewayType.cybersource,
    gatewayType.trust_my_travel,
    gatewayType.propay,
    gatewayType.propay_canada,
    gatewayType.powercash,
    gatewayType.emerchantpay,
    gatewayType.adyen,
    gatewayType.bambora,
    gatewayType.ntt_cybersource
];

module.exports = {
    gatewaysThatCanRefund,
    gatewaysThatCanVoid,
    gatewaysThatCanCapture
};
